import "./table-action-row.scss";

import React, { ReactNode } from "react";

import TableCellSpacer from "./TableCellSpacer";

type TableRowProps = {
  columnCount: number;
  text: ReactNode;
  onClick: () => void;
  hasTableCellSpacer?: boolean;
};

export default function TableActionRow(props: TableRowProps) {
  return (
    <tr className="generic-table-action-row">
      <td colSpan={props.columnCount}>
        <button onClick={props.onClick}>{props.text}</button>
      </td>
      {props.hasTableCellSpacer && <TableCellSpacer />}
    </tr>
  );
}
